/* tslint:disable */
/* eslint-disable */
/**
 * Vocalise.API.Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { User } from './User';
/**
 * 
 * @export
 * @interface VoiceType
 */
export interface VoiceType {
    /**
     * 
     * @type {number}
     * @memberof VoiceType
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof VoiceType
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VoiceType
     */
    description?: string | null;
    /**
     * 
     * @type {Array<User>}
     * @memberof VoiceType
     */
    users?: Array<User> | null;
}

/**
 * Check if a given object implements the VoiceType interface.
 */
export function instanceOfVoiceType(value: object): value is VoiceType {
    return true;
}

export function VoiceTypeFromJSON(json: any): VoiceType {
    return VoiceTypeFromJSONTyped(json, false);
}

export function VoiceTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VoiceType {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'description': json['description'] == null ? undefined : json['description'],
        'users': json['users'] == null ? undefined : ((json['users'] as Array<any>).map((require('./User') as typeof import('./User')).UserFromJSON)),
    };
}

export function VoiceTypeToJSON(json: any): VoiceType {
    return VoiceTypeToJSONTyped(json, false);
}

export function VoiceTypeToJSONTyped(value?: VoiceType | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'users': value['users'] == null ? undefined : ((value['users'] as Array<any>).map((require('./User') as typeof import('./User')).UserToJSON)),
    };
}

